import React, { Component } from 'react';

class UserSliderInputDruckfarbe extends Component{
  constructor(props) {
    super(props);
    this.state = {
      leftLabel: `${this.props.white}+cmyk`,
      rightLabel: "cmyk",
      overrideLabels: false
    }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const value = e.target.value;
    this.props.onChange(value);
    this.setLabels(value)
  }

  setLabels = (value) => {
    if(value <= 0 && !this.state.overrideLabels){
      this.setState({
        leftLabel: this.props.white
      })
    }
    else if(value > 0 && value < 100 && this.state.leftLabel !== `${this.props.white}+cmyk` && !this.state.overrideLabels){
      this.setState({
        leftLabel: `${this.props.white}+cmyk`
      })
    }
    if(this.state.rightLabel !== "cmyk" && !this.state.overrideLabels){
      this.setState({
        rightLabel: "cmyk"
      })
    }
  }

  componentDidMount = () => {
    const value = this.props.value;
    this.props.onChange(value)
  }

  componentDidUpdate = () => {
    if(this.props.textilePercentage >= 51 && !this.state.overrideLabels){
      this.setState({
        overrideLabels: true
      }, () => {
        this.setState({
          rightLabel: `cmyk+${this.props.white}`,
          leftLabel: `${this.props.white}`
        })
      })
    }
    else if(this.props.textilePercentage <= 50 && this.state.overrideLabels){
      this.setState({
        overrideLabels: false
      }, () => {
        this.setLabels(this.props.value)
      })
    }
    else if(this.props.textilePercentage <= 50 && !this.state.overrideLabels && this.state.leftLabel !== `${this.props.white}`){
      this.setLabels(this.props.value)
    }
    else if(this.props.textilePercentage <= 50 && !this.state.overrideLabels && this.props.value > 0 && this.state.leftLabel !== `${this.props.white}+cmyk`){
      this.setLabels(this.props.value)
    }
  }


  render() {
    const styles = this.props.styles

    return(
      <div key={this.props.name} className={styles.inputItem}>
          <div className={styles.info}>
            {this.props.label}
          </div>
          <p>{this.props.helpText}</p>
          <div className={styles.slider}>
            <aside className={styles.sliderData}>
              <i>{100 - this.props.value}{this.props.showPercentage && "%"}</i>
              <i>{this.props.value}{this.props.showPercentage && "%"}</i>
            </aside>
            <input onChange={this.handleChange} type="range"
              name={this.props.name}
              value={this.props.value}
              max="100"
              min="0"
              step="1"
            />
            <aside>
              <i>{this.state.leftLabel}</i>
              <i>{this.state.rightLabel}</i>
            </aside>
          </div>
      </div>
      
    );
  }
}

export default UserSliderInputDruckfarbe;



// WEBPACK FOOTER //
// ./src/components/calculator/step-by-step/s_slider_druckfarbe.js